const resumeConfig = {
    url : "https://drive.google.com/file/d/183QknCoH7HQg4vbuli1xMdUTIIJlE3ao/preview",
}

export default resumeConfig;
// https://drive.google.com/file/d/183QknCoH7HQg4vbuli1xMdUTIIJlE3ao/view?usp=sharing